import {tva} from "@gluestack-ui/nativewind-utils/tva";
import {Box} from "@hosttools/frontend";
import type React from "react";

type Props = {
    children: React.ReactNode;
    className?: string;
};

const cardFooterStyle = tva({
    base: "px-6 py-3 border-t border-b border-blueGray-200 border-solid flex flex-row items-center justify-end"
});

const CardFooter: React.FC<Props> = ({children, className}) => {
    return <Box className={cardFooterStyle({className})}>{children}</Box>;
};

export default CardFooter;
